import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const Floor26Component = ({unitStatus}) => {
  console.log('unitStatus', unitStatus);
    useEffect(() => {
        // Initialize ImageMapPro after the component mounts
        const initializeImageMap = () => {
            if (window.ImageMapPro) {
                window.ImageMapPro.init('#image-map-pro', {
                  "id": "3ab383d8-c222-4a10-b5bd-4e929a7b71b3", "general": {
    "name": "Floor 13,15,17,19,22,24,26,28,32,36"
}, "artboards": [{
"background_type": "image",
"image_url": "https://greendirectorydata.s3.us-east-2.amazonaws.com/GPP8%20KP%206-%2013th%2C%2015th%2C%2017th%2C%2019th%2C%2022nd%2C%2024th%2C%2026th%2C%2028th%2C%2032nd%2C%2036th%20FLOOR%20copy.png",
"width": 3810,
"height": 2579,
"use_image_size": true,
"children": [{
    "id": "9332dee1-c516-4b8f-a803-92dfcd08de09",
    "title": "Poly",
    "type": "poly",
    "x": 48.70503597122302,
    "y": 2.5993368982596006,
    "width": 17.913669064748213,
    "height": 45.488603301151244,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[12].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[12].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[12].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[12].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[12].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/13';"
    },
    "x_image_background": 48.70503597122302,
    "y_image_background": 2.5993368982596006,
    "points": [{
        "x": 98.79518072289156,
        "y": 0.46728971962616817
    }, {
        "x": 0.8032128514056224,
        "y": 0
    }, {
        "x": 0,
        "y": 21.72897196261682
    }, {
        "x": 42.971887550200805,
        "y": 21.49532710280374
    }, {
        "x": 42.971887550200805,
        "y": 94.62616822429906
    }, {
        "x": 71.8875502008032,
        "y": 94.39252336448598
    }, {
        "x": 71.4859437751004,
        "y": 100
    }, {
        "x": 89.95983935742971,
        "y": 99.76635514018692
    }, {
        "x": 89.95983935742971,
        "y": 94.85981308411215
    }, {
        "x": 100,
        "y": 94.62616822429906
    }]
}, {
    "id": "04c8c732-6fad-4368-bdf8-e4b9121f236a",
    "title": "Poly",
    "type": "poly",
    "x": 66.4748201438849,
    "y": 2.5993368982596006,
    "width": 32.086330935251794,
    "height": 45.27603973432344,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[11].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[11].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[11].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[11].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[11].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/12';"
    },
    "x_image_background": 66.4748201438849,
    "y_image_background": 2.5993368982596006,
    "points": [{
        "x": 99.77578475336323,
        "y": 36.61971830985916
    }, {
        "x": 100,
        "y": 0.2347417840375587
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 0.672645739910314,
        "y": 94.60093896713614
    }, {
        "x": 5.15695067264574,
        "y": 94.83568075117371
    }, {
        "x": 5.605381165919283,
        "y": 100
    }, {
        "x": 15.695067264573993,
        "y": 99.76525821596243
    }, {
        "x": 16.143497757847534,
        "y": 95.53990610328638
    }, {
        "x": 31.838565022421523,
        "y": 95.07042253521126
    }, {
        "x": 31.614349775784756,
        "y": 36.85446009389671
    }]
}, {
    "id": "fdf740aa-ade5-497a-b88d-33b165f27bad",
    "title": "Poly",
    "type": "poly",
    "x": 86.40287769784173,
    "y": 55.20881968814246,
    "width": 12.014388489208628,
    "height": 43.57553406490364,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[10].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[10].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[10].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[10].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[10].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/11';"
    },
    "x_image_background": 86.40287769784173,
    "y_image_background": 55.20881968814246,
    "points": [{
        "x": 0,
        "y": 0.7317072689615495
    }, {
        "x": 98.80239520958082,
        "y": 0
    }, {
        "x": 100,
        "y": 26.341461682615634
    }, {
        "x": 86.22754491017962,
        "y": 26.341461682615634
    }, {
        "x": 88.62275449101799,
        "y": 83.65853108460338
    }, {
        "x": 55.08982035928142,
        "y": 83.41462866161618
    }, {
        "x": 53.892215568862234,
        "y": 99.99999835618613
    }, {
        "x": 0,
        "y": 100
    }]
}, {
    "id": "984ca01b-ac95-477a-b64e-17d8d4911192",
    "title": "Poly",
    "type": "poly",
    "x": 76.11510791366906,
    "y": 55.315101471556375,
    "width": 10.2158273381295,
    "height": 43.469249416287056,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[9].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[9].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[9].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[9].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[9].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/10';"
    },
    "x_image_background": 76.11510791366906,
    "y_image_background": 55.315101471556375,
    "points": [{
        "x": 0,
        "y": 0
    }, {
        "x": 100,
        "y": 0.24449877750611246
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 0,
        "y": 99.26650366748166
    }]
}, {
    "id": "da3c87a7-b039-4e73-84cd-98537738afca",
    "title": "Poly",
    "type": "poly",
    "x": 65.75539568345323,
    "y": 55.42138325497028,
    "width": 10.287769784172667,
    "height": 43.256685849459245,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[8].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[8].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[8].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[8].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[8].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/9';"
    },
    "x_image_background": 65.75539568345323,
    "y_image_background": 55.42138325497028,
    "points": [{
        "x": 0,
        "y": 0.2457002457002457
    }, {
        "x": 99.3006993006993,
        "y": 0
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 0,
        "y": 99.26289926289927
    }]
}, {
    "id": "d04184df-3e68-4220-bbfe-6daea2fd3c97",
    "title": "Poly",
    "type": "poly",
    "x": 55.39568345323741,
    "y": 55.315101471556375,
    "width": 10.287769784172667,
    "height": 43.256685849459245,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[7].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[7].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[7].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[7].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[7].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/8';"
    },
    "x_image_background": 55.39568345323741,
    "y_image_background": 55.315101471556375,
    "points": [{
        "x": 0,
        "y": 0
    }, {
        "x": 99.3006993006993,
        "y": 0.4914004914004914
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 0.6993006993006993,
        "y": 100
    }]
}, {
    "id": "fd7f806d-9e0a-4a8f-8ed1-3f862a1c143f",
    "title": "Poly",
    "type": "poly",
    "x": 45.10791366906475,
    "y": 55.42138325497028,
    "width": 10.143884892086326,
    "height": 43.46924941628704,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[6].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[6].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[6].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[6].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[6].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/7';"
    },
    "x_image_background": 45.10791366906475,
    "y_image_background": 55.42138325497028,
    "points": [{
        "x": 0,
        "y": 0.24449877750611246
    }, {
        "x": 99.29078014184397,
        "y": 0
    }, {
        "x": 100,
        "y": 99.75550122249389
    }, {
        "x": 0.7092198581560284,
        "y": 100
    }]
}, {
    "id": "37040fd8-37cd-43c1-8b17-70adc8a68374",
    "title": "Poly",
    "type": "poly",
    "x": 34.748201438848916,
    "y": 55.42138325497028,
    "width": 10.287769784172667,
    "height": 43.256685849459245,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[5].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[5].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[5].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[5].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[5].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/6';"
    },
    "x_image_background": 34.748201438848916,
    "y_image_background": 55.42138325497028,
    "points": [{
        "x": 0,
        "y": 0
    }, {
        "x": 98.6013986013986,
        "y": 0.2457002457002457
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 0.6993006993006993,
        "y": 99.75429975429975
    }]
}, {
    "id": "4ea868b4-fa88-46f4-ae59-56666fa1d4f7",
    "title": "Poly",
    "type": "poly",
    "x": 24.316546762589926,
    "y": 55.315101471556375,
    "width": 10.35971223021583,
    "height": 43.469249416287056,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[4].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[4].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[4].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[4].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[4].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/5';"
    },
    "x_image_background": 24.316546762589926,
    "y_image_background": 55.315101471556375,
    "points": [{
        "x": 0.6944444444444444,
        "y": 0
    }, {
        "x": 99.30555555555556,
        "y": 0.24449877750611246
    }, {
        "x": 100,
        "y": 99.51100244498777
    }, {
        "x": 0,
        "y": 100
    }]
}, {
    "id": "7267f223-23a7-45f2-9608-e457cf8fd7f6",
    "title": "Poly",
    "type": "poly",
    "x": 14.028776978417264,
    "y": 55.42138325497028,
    "width": 10.287769784172662,
    "height": 43.36296763287315,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[3].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[3].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[3].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[3].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[3].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/4';"
    },
    "x_image_background": 14.028776978417264,
    "y_image_background": 55.42138325497028,
    "points": [{
        "x": 0,
        "y": 0.24509803921568626
    }, {
        "x": 99.3006993006993,
        "y": 0
    }, {
        "x": 100,
        "y": 99.75490196078431
    }, {
        "x": 0,
        "y": 100
    }]
}, {
    "id": "84b67667-6e34-4499-a354-5ccccae091d1",
    "title": "Poly",
    "type": "poly",
    "x": 3.5251798561151078,
    "y": 55.20881968814246,
    "width": 10.503597122302157,
    "height": 43.46924941628706,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[2].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[2].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[2].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[2].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[2].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/3';"
    },
    "x_image_background": 3.5251798561151078,
    "y_image_background": 55.20881968814246,
    "points": [{
        "x": 1.36986301369863,
        "y": 0.4889975550122249
    }, {
        "x": 0,
        "y": 83.37408312958435
    }, {
        "x": 38.35616438356164,
        "y": 83.61858190709046
    }, {
        "x": 36.986301369863014,
        "y": 100
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 99.31506849315068,
        "y": 0
    }]
}, {
    "id": "823e723d-b05e-4d66-ab9b-f96540c5ec56",
    "title": "Poly",
    "type": "poly",
    "x": 3.8129496402877696,
    "y": 2.5993368982596006,
    "width": 19.640287769784173,
    "height": 45.27603973432344,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[1].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[1].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[1].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[1].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[1].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/2';"
    },
    "x_image_background": 3.8129496402877696,
    "y_image_background": 2.5993368982596006,
    "points": [{
        "x": 99.63369963369964,
        "y": 0
    }, {
        "x": 0.3663003663003663,
        "y": 0
    }, {
        "x": 0,
        "y": 27.464788732394368
    }, {
        "x": 47.61904761904761,
        "y": 27.699530516431924
    }, {
        "x": 47.985347985347985,
        "y": 95.07042253521126
    }, {
        "x": 74.35897435897436,
        "y": 94.83568075117371
    }, {
        "x": 73.992673992674,
        "y": 99.53051643192488
    }, {
        "x": 90.47619047619048,
        "y": 100
    }, {
        "x": 91.20879120879121,
        "y": 95.30516431924883
    }, {
        "x": 100,
        "y": 95.07042253521126
    }]
}, {
    "id": "897a15d7-c2e5-4a83-9460-bcb0d1bf5415",
    "title": "Poly",
    "type": "poly",
    "x": 23.381294964028775,
    "y": 2.3867733314317916,
    "width": 17.84172661870504,
    "height": 45.59488508456515,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[0].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[0].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[0].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[0].status.toUpperCase(),
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
          "fontFamily": "barlow",
          "fontSize": 26,
          "lineHeight": 22,
          "color": "#ad937b",
          "textAlign": "left"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    "actions": {
        "click": unitStatus && unitStatus[0].status === 'available' ? "run-script" : "none",
        "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/26/1';"
    },
    "x_image_background": 23.381294964028775,
    "y_image_background": 2.3867733314317916,
    "points": [{
        "x": 100,
        "y": 22.144522144522146
    }, {
        "x": 100,
        "y": 0.2331002331002331
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 0.4032258064516129,
        "y": 94.63869463869464
    }, {
        "x": 10.080645161290322,
        "y": 94.63869463869464
    }, {
        "x": 9.67741935483871,
        "y": 100
    }, {
        "x": 28.62903225806452,
        "y": 99.76689976689977
    }, {
        "x": 28.225806451612907,
        "y": 95.57109557109557
    }, {
        "x": 56.85483870967742,
        "y": 94.63869463869464
    }, {
        "x": 57.25806451612904,
        "y": 21.678321678321677
    }]
}]
}], "version": "6.0.20"
});
            }
        };

        // Wait for the script to load
        const script = document.createElement('script');
        script.src = '/js/image-map-pro.min.js';
        script.onload = initializeImageMap;
        document.head.appendChild(script);
    }, []);

    return (
        // <div>
        //     <div id="image-map-pro"></div>
        // </div>
        <div justifyContent="center" alignItems="center">
          {/* Responsive container for the image map */}
          <div width={{ base: '100%', md: '80%' }} height={{ base: '300px', md: '400px' }} position="relative">
            {/* Ensure the image map fills its parent container */}
            <div id="image-map-pro" height="100%" width="100%"></div>
          </div>
        </div>
    );
}

export default Floor26Component;
